import { gql } from "@grandvisionhq/graphql";
const user = gql`
  fragment BookAppointmentUser on Customer {
    email
    defaultBillingAddress {
      salutation
      firstName
      lastName
      postalCode
    }
    personalDetails {
      salutation
      firstName
      lastName
      phone
      dateOfBirth
      ssn
    }
    optIns {
      id
      literalText
      uiType
      value
    }
  }
`;
const GET_BOOK_APPOINTMENT_USER = gql`
  query GetBookAppointmentUser {
    me {
      id
      ...BookAppointmentUser
    }
  }
  ${user}
`;
export {
  GET_BOOK_APPOINTMENT_USER
};
//# sourceMappingURL=get-user.js.map
